import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceInfo } from 'ngx-device-detector';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'browser-not-compatible-dialog-body',
    templateUrl: './browser-not-compatible-dialog-body.component.html',
    styleUrls: ['./browser-not-compatible-dialog-body.component.scss']
})
export class BrowserNotCompatibleDialogBodyComponent {
    deviceInfo: DeviceInfo;
    browserMinVersion: number;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.deviceInfo = data.deviceInfo;
        this.browserMinVersion = data.browserMinVersion;
    }
}
